import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData, { DEFAULT_BUTTON_CONFIG } from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import ClockScreen from './ClockScreen';
import PracticeScreen from './PracticeScreen';
import ABCyaLib from '@abcya/abcya_lib';
import GameScreen from './GameScreen';
import FontKeys from '../FontKeys';

export default class SelectLevelScreen extends Phaser.Scene {
  static get KEY() { return 'SelectLevelScreen'; }

  constructor() {
    super({ key: SelectLevelScreen.KEY });
  }

  create() {
    const backgroundImage = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._select_background, this).setOrigin(0);

    const headerText = ABCyaPhaser.Text.addText(this.scale.width / 2,78,110, 0xeaf7d2, FontKeys._dimboregular, ABCyaPhaser.Localization.instance.getLocalizedString('select_level_screen.header'), this, true).setShadow(6,6,'#00000073')
      .setPadding(5);

    const levelsLocked = gameData.LEVELS_LOCKED;

    // create practice button
    const name = 'select_button0';
    const button = this.add.container(this.scale.width / 2,this.scale.height - 500);
    const buttonBg = ABCyaPhaser.Images.addImage(0,0,name, button);
    ABCyaPhaser.Container.setContainerInteractive(button);
    const buttonTxt = ABCyaPhaser.Text.addText(-4,-10,86, 0xffffff, FontKeys._dimboregular, ABCyaPhaser.Localization.instance.getLocalizedString('select_level_screen.practice_button'), button, true).setShadow(6,6,'#000000bf')
      .setPadding(5);
    ABCyaPhaser.Buttons.convertToButton(button, { soundKey: SoundAssetKeys._click, onClick: () => this.selectButton(button), ...DEFAULT_BUTTON_CONFIG });
    button.number = 1;
    button.scale = 0;
    ABCyaPhaser.Tweens.addTween(button, 300, { delay: 700, scale: 1.3 }, Phaser.Math.Easing.Linear, () => {
      ABCyaPhaser.Tweens.addTween(button, 250, { scale: 1 }, Phaser.Math.Easing.Bounce.Out);
    });

    // create the level buttons
    for (let i = 1; i < levelsLocked.length; i++) {
      const name = `select_button${i}`;

      const button = ABCyaPhaser.Buttons.addDefaultButton(0,0,name, null, SoundAssetKeys._click, () => this.selectButton(button), this, { ...DEFAULT_BUTTON_CONFIG });
      let lock = null;

      const levelLocked = levelsLocked[i];

      if (levelLocked) {
        button.disableInteractive();
        lock = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._select_button_lock, this);
      }

      let xPos = 0;
      let yPos = 0;

      const incY = 100;

      switch (i) {

        case 1:
          xPos = this.scale.width / 2 - 200;
          yPos = this.scale.height - (3 * incY);
          break;

        case 2:
          xPos = this.scale.width / 2 + 200;
          yPos = this.scale.height - (3 * incY);
          break;

        case 3:
          xPos = this.scale.width / 2 - 200;
          yPos = this.scale.height - (1 * incY);
          break;

        case 4:
          xPos = this.scale.width / 2 + 200;
          yPos = this.scale.height - (1 * incY);
          break;
      };

      button.x = xPos;
      button.y = yPos;

      button.number = i + 1;
      button.scale = 0;

      if (lock) {
        lock.scale = 0;
        lock.x = xPos;
        lock.y = yPos;

        ABCyaPhaser.Tweens.addTween(lock, 300, { delay: (i * 100) + 700, scale: 1.3 }, Phaser.Math.Easing.Linear, () => {
          ABCyaPhaser.Tweens.addTween(lock, 250, { scale: 1 }, Phaser.Math.Easing.Bounce.Out);
        });
      }

      ABCyaPhaser.Tweens.addTween(button, 300, { delay: (i * 100) + 700, scale: 1.3 }, Phaser.Math.Easing.Linear, () => {
        ABCyaPhaser.Tweens.addTween(button, 250, { scale: 1 }, Phaser.Math.Easing.Bounce.Out);
      });
    }

    this.cameras.main.zoom = 0;
    this.transitionIn();
  }

  transitionIn () {
    const totalRotation = 2 * 360;
    this.tweens.add({ targets: { value: 0 },
      duration: 700,
      ease: Phaser.Math.Easing.Linear,
      props: { value: 1 },
      onUpdate: (tween, target) => {
        this.cameras.main.setAngle(target.value * totalRotation);
      } });
    ABCyaPhaser.Tweens.addTween(this.cameras.main,700, { zoom: 1 }, Phaser.Math.Easing.Linear);
  }

  selectButton (button) {
    gameData.CURRENT_LEVEL = button.number - 1;

    this.transitionOut();
  }

  transitionOut () {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._transition, this);

    const totalRotation = -2 * 360;
    this.tweens.add({ targets: { value: 0 },
      duration: 700,
      ease: Phaser.Math.Easing.Linear,
      props: { value: 1 },
      onUpdate: (tween, target) => {
        this.cameras.main.setAngle(target.value * totalRotation);
      } });
    ABCyaPhaser.Tweens.addTween(this.cameras.main,700, { zoom: 0 }, Phaser.Math.Easing.Linear, () => this.cleanUp(gameData.CURRENT_LEVEL === 0));
  }

  cleanUp (isPractice) {
    const nextScene = ABCyaLib.Environment.instance.gameConfig.gameMode === null ? ClockScreen.KEY : GameScreen.KEY;
    this.scene.start(isPractice ? PracticeScreen.KEY : nextScene);
  }
}